import App        from "@/views/application/index.vue"
import Index      from "@/views/Index.vue"
import Denuncia   from "@/views/Denuncia.vue"

import Check      from "@/components/Pages/Login/Check.vue"
import Recovery   from "@/components/Pages/Login/Recovery.vue"
import Enviado    from "@/components/Pages/Login/Enviado.vue"
import Login      from "@/components/Pages/Login/Login.vue"

import app_routes from './application.js'
import den_routes from './Denuncia.js'

export default [
	// Toda rota não registrada, redireciona para Index
	{
		path: "*",
		redirect: "/"
	},

	{
		path: "/",
		redirect: "/App/Dashboard/Graficos",
		component: Index,
		children: [
			{
				path: "Login",
				component: Login,
			},

			{
				path: "Recuperar/Senha",
				component: Recovery,
			},

			{
				path: "Secret",
				component: Check,
			},

			{
				path: "Email/Enviado",
				component: Enviado,
			},
		]
	},

	{
		path: "/Denuncia",
		component: Denuncia,
		props: true,
		children: den_routes
	},

	// App
	{
		path: "/App",
		component: App,
		props: true,
		children: app_routes,
		beforeEnter: (to, from, next) => {
			const auth  = localStorage.auth
			const token = localStorage.token

			if ( auth == "true" && token ) next();
			else next("/Login")

		},
	},
]